module.exports = __webpack_public_path__ + "static/media/rebirth_29.1253205e.jpg";